import { connect } from 'react-redux';
import { getFormInitialValues, getFormValues, isInvalid, isPristine, isSubmitting, reset, submit } from 'redux-form';
import { get } from 'lodash';
import { loadAllDictionaries } from '../AdminTools/components/Dictionary/actions';
import {
  checkInteractionDiscovery,
  closeResetDialog,
  fromMonitoredToAvailable,
  getChargerDetails,
  getOldSSPData,
  getSSPData,
  initViewEditChargerForm,
  loadChargerConfiguration,
  lockChargerConfiguration,
  onChargerDetailsTabExport,
  openResetDialog,
  resetCharger,
  resetFields,
  resetRejectedFields,
  setActiveTab,
  toggleConfigurationConfirmationDialogOpen,
  toggleReinitForm,
  toggleShowConfigurationLockedPopup,
  toggleSnackbar,
  unlockChargerConfiguration,
  updateChargerBody,
  updateChargerConfiguration,
} from './actions';
import ChargerDetails from './component';
import { chargerConfigurationFormId } from './components/ChargerConfiguration/constants';
import { FORM_NAME } from './components/ChargerDetailsForm';
import { clear, toggleErrorSnackbar, toggleFirmwareUpdateModal, toggleSnackBar } from './components/FirmwareUpdateDialog/actions';
import { getUser } from '../Login/selectors';
import { UserIsAuthenticated } from '../../common/services/AuthenticationRules';
import { getPlates } from '../Login/components/TokenExpireDialog/actions';
import { multiFwUpdateTableId } from '../MultiFwUpdate/constants';
import { emptyQuery } from '../../common/components/AdvancedSearch/QueryBuilder/constants';
import { changeFilter, changeFilterQuery, setAdvancedSearchQuery } from '../../common/components/SSPList/actions';

const mapStateToProps = (state) => ({
  ...state.chargerDetails,
  config: state.appConfig.config,
  dictionaries: state.dictionaries.storedDictionaries,
  user: getUser(state),
  detailsForm: {
    values: getFormValues(FORM_NAME)(state),
  },
  configurationForm: {
    values: getFormValues(chargerConfigurationFormId)(state),
    initialValues: getFormInitialValues(chargerConfigurationFormId)(state),
    pristine: isPristine(chargerConfigurationFormId)(state),
    invalid: isInvalid(chargerConfigurationFormId)(state),
    submitting: isSubmitting(chargerConfigurationFormId)(state),
  },
  formValues: getFormValues('chargerDetails')(state),
  initialFormValues: getFormInitialValues('chargerDetails')(state),
  formPristine: isPristine('chargerDetails')(state),
  showSuccesfullUpdateSnackBar: state.firmwareUpdateDialog.showSuccesfullUpdateSnackBar,
  showErrorSnackbar: state.firmwareUpdateDialog.showErrorSnackbar,
  error: state.firmwareUpdateDialog.error,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  toggleFirmwareUpdateModal: (flag) => dispatch(toggleFirmwareUpdateModal(flag)),

  clearFirmwareUpdateModal: () => dispatch(clear()),

  closeFirmwareUpdateSnackBar: () => dispatch(toggleSnackBar(false)),

  loadCharger: (uuid) => dispatch(getChargerDetails(uuid)),

  fromMonitoredToAvailable: (chargerBody) => dispatch(fromMonitoredToAvailable(chargerBody)),

  initViewEditChargerForm: (data) => dispatch(initViewEditChargerForm(data)),

  toggleSnackbar: (flag) => dispatch(toggleSnackbar(flag)),

  toggleErrorSnackbar: (flag) => dispatch(toggleErrorSnackbar(flag)),

  toggleReinitForm: (flag) => dispatch(toggleReinitForm(flag)),

  updateChargerBody: (chargerBody) => dispatch(updateChargerBody(chargerBody)),

  setActiveTab: (tab, navigate) =>
    ownProps.setActiveTab ? ownProps.setActiveTab(tab, navigate, ownProps) : dispatch(setActiveTab(tab, navigate, ownProps)),

  loadAllDictionaries: (filter) => dispatch(loadAllDictionaries(filter)),

  openResetDialog: (command) => dispatch(openResetDialog(command)),

  closeResetDialog: () => dispatch(closeResetDialog()),

  resetCharger: (id, command) => dispatch(resetCharger(id, command)),

  // old stuff, for tables with no pagination implemented on api (failures, activities, sessions)
  getOldSSPData: (id, url, page_token = 0, page_size = 10) => dispatch(getOldSSPData(id, url, page_token, page_size)),

  getSSPData: (
    chargerId,
    id,
    { page_token: pageToken = 0, page_size: pageSize = 10, filter_by: filterBy = {}, sorting = {}, dynamicSectionName = '' },
  ) => {
    const selectedChargerId = get(ownProps, 'chargerId') || chargerId;

    dispatch(
      getSSPData(id, dynamicSectionName, selectedChargerId, {
        page_token: pageToken,
        page_size: pageSize,
        filter_by: filterBy,
        sorting,
      }),
    );
  },

  onRemoteSubmit: () => dispatch(submit(FORM_NAME)),

  onConfigurationSubmit: () => dispatch(submit(chargerConfigurationFormId)),

  onConfigurationReset: (chargerUUID) => {
    dispatch(resetRejectedFields());
    dispatch(reset(chargerConfigurationFormId));
    if (chargerUUID) {
      dispatch(unlockChargerConfiguration(chargerUUID));
    }
  },

  checkInteractionDiscovery: () =>
    dispatch(checkInteractionDiscovery(_.get(ownProps, 'chargerId') || _.get(ownProps, 'match.params.chargerId'))),

  setConfigurationConfirmationDialogOpen: () => dispatch(toggleConfigurationConfirmationDialogOpen(true)),

  setConfigurationConfirmationDialogClosed: () => dispatch(toggleConfigurationConfirmationDialogOpen(false)),

  loadChargerConfiguration: (uuid) => dispatch(loadChargerConfiguration(uuid)),

  updateChargerConfiguration: (uuid, updatedParameters, lockInterval) =>
    dispatch(updateChargerConfiguration(uuid, updatedParameters, lockInterval)),

  lockChargerConfiguration: (uuid) => dispatch(lockChargerConfiguration(uuid)),

  toggleShowConfigurationLockedPopup: (showLockedPopup) => dispatch(toggleShowConfigurationLockedPopup(showLockedPopup)),

  resetField: (nodeName, parameterName) => dispatch(resetFields([{ nodeName, parameterName }])),

  unlockConfig: (uuid) => dispatch(unlockChargerConfiguration(uuid)),

  getPlates: (id, chargerId) =>  dispatch(getPlates(id, {
      filter_by: [
        {
          id: "c_uuid",
          value: chargerId
        }
      ],
    })),

  onChargerDetailsTabExport: (exportProps) => dispatch(onChargerDetailsTabExport(exportProps)),

  // Cleaning MultiFW table filters after leaving Charger Details page
  clearMultiFwTableFilters: () => {
    dispatch(changeFilter(multiFwUpdateTableId, null));
    dispatch(changeFilterQuery(multiFwUpdateTableId, emptyQuery));
    dispatch(setAdvancedSearchQuery(multiFwUpdateTableId, emptyQuery));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(UserIsAuthenticated(ChargerDetails));
